import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { IAssetData, IConfig } from '../../helpers/data/assetData'

const defaultConfig = {}
const defaultStyle = {}

const ImageAssetElement = styled.img`
	width: 100%;
	height: 100%;
`

interface IImageAssetProps {
	assetData: IAssetData
	path: string
	onAssetLoaded: () => void
	alt?: string
	ariaHidden?: boolean
}

class ImageAsset extends PureComponent<IImageAssetProps> {
	buildStyle = (config: IConfig) => {
		return config.style || defaultStyle
	}

	formatPath(rootPath: string, assetPath: string) {
		let path = rootPath + assetPath
		// Adding suffix to prevent loading of cached versions of assets since we added a new crossOrigin rule
		const suffix = '5hf4el9'
		const lastDotIndex = path.lastIndexOf('.')
		const questionIndex = path.indexOf('?', lastDotIndex)
		if (questionIndex === -1) {
			path += '?sfx=' + suffix
		} else {
			path += '&sfx=' + suffix
		}
		return path
	}

	render() {
		const assetData = this.props.assetData
		const config: IConfig = assetData.config || defaultConfig

		return (
			<ImageAssetElement
				crossOrigin={'anonymous'}
				src={this.formatPath(this.props.path, assetData.path)}
				onLoad={this.props.onAssetLoaded}
				style={this.buildStyle(config)}
				alt={this.props.alt || ''}
				aria-hidden={this.props.ariaHidden}
			/>
		)
	}
}

export default ImageAsset
